let colInput = (t, key) => {
    return {
        render: (h, params) => {
            return h("Input", {
                props: {
                    type: "text",
                    value: t.data[params.index][key],
                    placeholder: key == 'kdBillCode' || key == 'Goods' || key == 'GoodsValue' ? window.vm.$i18n.t('PromotionCenter.pleaseInput') : window.vm.$i18n.t('PromotionCenter.pleaseInput2'),
                },
                on: {
                    "on-blur": (event) => {
                        t.data[params.index][key] = event.target.value;
                    },
                },
            });
        },
    };
}
let colSelect = (t) => {
    return {
        render: (h, params) => {
            return h(
                "Select", {
                props: {
                    value: t.data[params.index].Goodsid,
                    placeholder: window.vm.$i18n.t('PromotionCenter.pleaseChose'),
                },
                on: {
                    "on-change": (event) => {
                        t.data[params.index].Goodsid = event;
                        t.GoodList.forEach(ele => {
                            if (ele.GoodsID == event)
                                t.data[params.index].GoodsType = ele.GoodsName
                        });
                    },
                },
            },
                t.GoodList.map((item) => {
                    return h("Option", {
                        props: {
                            value: item.GoodsID,
                            label: item.GoodsName,
                        },
                    });
                })
            );
        },
    };
}
let colSelectName = (t) => {
    return {
        render: (h, params) => {
            return h("Select", { props: { value: t.data[params.index].Goods, placeholder: "請選擇(選填)", multiple: true, filterable: true, maxTagCount: 3, }, on: { "on-change": (e) => { t.data[params.index].Goods = e }, "on-clear": (e) => { t.data[params.index].Goods = e } }, },

                t.goodsName.map((item, index) => { return h("Option", { props: { value: item, label: item, }, }); }));
        },
    };
}
let colTop = (t) => {
    return {
        render: (h, params) => {
            if (params.index != 0) {
                return h(
                    "Button", {
                    props: {
                        type: "error",
                        size: "small",
                    },
                    on: {
                        "click": () => {
                            t.data.splice(params.index, 1);
                        },
                    },
                },
                    window.vm.$i18n.t('Mypackage.Delete')
                );
            }
        },
    };
}
let AddressCol = (t) => {
    return {
        render: (h, params) => {
            let row = params.row;
            let str = `聯系人：${row.Signer}，手機號：${row.Phone} 電話：${row.Tel} 地址：${row.CountryName}-${row.ProviceName} ${row.CityName ? row.CityName : ""} ${row.AreaName ? row.AreaName : ""} ${row.Address ? row.Address : ""} `;
            let ztStr = `自提點：${row.Name} 地址：${row.Address} ,手機號：${row.Phone} 電話：${row.Tel}, 最大重量限制：${row.MaxWeight}, 是否支持到付:${row.IsDf == 1 ? '是' : '否'}`;
            return h("span", t.info.ServiceType == 2 ? str : ztStr);
        }
    }
}

let headerTop = (t) => {
    return {
        renderHeader: (h, index) => {
            return h(
                "Button", {
                props: {
                    type: "primary",
                    size: "small",
                },
                on: {
                    "click": (e) => {
                        if (t.data.length > 7) {
                            t.$Message.warning('壹次最多為8個');
                            return false;
                        }
                        let info = {
                            kdBillCode: "",
                            Goods: "",
                            Goodsid: "",
                            Number: "",
                            Goods_meno: "",
                            MemberID: localStorage.getItem("userID")
                        }
                        t.data.push(info)
                    },
                },
            },
                "+添加貨品"
            );
        },
    };
}

let baseInfo = () => {
    return {
        render: (h, params) => {
            return h("div", [
                h("div", [
                    h("div", {
                        domProps: {
                            style: "display:flex;line-height: 30px",
                            innerHTML: `<div style="width: 260px;" >快遞單號：<span style="color: #999;font-weight:bold;">${params.row.kdBillCode}</span></div>
                  <div style="width: 220px">尺寸(cm)：<span style="color: #515a6e">${params.row.Size ? params.row.Size : 0 * 0 * 0}</span></div>`,
                        },
                    }),
                    h("div", {
                        domProps: {
                            style: "display:flex;line-height: 30px",
                            innerHTML: ` 
              <div style="width: 260px">實際重量：<span style="color: #515a6e">${params.row.Weight
                                }（kg）</span></div>
                  <div style="width: 220px">體積重量：<span style="color: #515a6e">${params.row.Weight2
                                }（kg）</span></div>`,
                        },
                    }),

                    h("div", {
                        domProps: {
                            style: "display:flex;line-height: 30px",
                            innerHTML: `  <div style="width: 260px;">貨物價值:<span style="color: #515a6e">${params.row.GoodsValue + "" ? params.row.GoodsValue : 0
                                }$</span></div>
                `,
                        },
                    }),

                    h("div", {
                        domProps: {
                            style: "display:flex;line-height: 30px",
                            innerHTML: `<div style="width: 260px;">到庫時間：<span style="color: #515a6e">${params.row.dd_time ? params.row.dd_time : "未到庫"
                                }</span></div>
                  `,
                        },
                    }),
                    h("div", {
                        domProps: {
                            style: "display:flex;line-height: 30px",
                            innerHTML: `  <div style="width: 400px;">上架時間：<span style="color: #515a6e">${params.row.inplaceTime ? params.row.inplaceTime : "<span style='color: #f00'>『貨物未上架,請耐心等候上架後才可以申請打包』</span>"
                                }</span></div>
                `,
                        },
                    })
                ]),
            ]);
        },
    }
}

let delBag = (t) => {
    return {
        render: (h, params) => {
            return h("div", [
                h(
                    "Button", {
                    style: "display: block; width: 100%; margin-bottom: 4px",
                    props: {
                        type: "primary",
                        size: "small",
                    },
                    on: {
                        click: () => {
                            t.showImg(params.row)
                        },
                    },
                },
                    window.vm.$i18n.t('Mypackage.Picture')
                ),
                h(
                    "Button", {
                    style: "display: block; width: 100%; margin-bottom: 4px",
                    props: {
                        type: "warning",
                        size: "small",
                    },
                    on: {
                        click: () => {
                            t.changeModal(params.row)
                        },
                    },
                },
                    window.vm.$i18n.t('Mypackage.Edit')
                ),
                h(
                    "Button", {
                    style: "display: block; width: 100%; margin-bottom: 4px",
                    props: {
                        type: "error",
                        size: "small",
                    },
                    on: {
                        click: () => {
                            t.delModal(params)
                        },
                    },
                },
                    window.vm.$i18n.t('Mypackage.Delete')
                ),
            ]);
        },
    }
}

export {
    colInput,
    colSelect,
    headerTop,
    colTop,
    baseInfo,
    delBag,
    AddressCol,
    colSelectName
}


// WEBPACK FOOTER //
// ./src/pages/view/homeManage/index.js